<template>
  <div class="flex flex-col lg:flex-row h-screen">
    <div class="login-bg h-40 lg:h-screen lg:w-full shrink-0 lg:shrink">
      <div class="absolute z-10 top-5 right-5 lg:top-10 lg:right-10 lg:p-10">
        <img src="../assets/img/logo.png" alt="" class="w-10 lg:w-20">
        <h1 class="text-xl mt-4 lg:text-5xl lg:mt-10">هتل تبرک</h1>
        <h3 class="mt-2 lg:mt-4">پنل مدیریت</h3>
      </div>
    </div>

    <div id="login-form" class="flex p-6 py-10 h-full lg:p-10 lg:w-full lg:items-center lg:h-screen">
      <div class="lg:w-[70%] mx-auto">
        <h1 class="text-xl text-center">ورود به پنل</h1>
        <form @submit.prevent="login">
          <div class="mt-10">
            <label>شماره همراه</label>
            <input type="tel" class="bg-dark-form rounded-lg w-full mt-4 p-3" required
                   placeholder="شماره همراه خود را وارد کنید" v-model="inputPhone.value">
          </div>

          <div class="mt-10">
            <label>رمز عبور</label>
            <input type="password" class="bg-dark-form rounded-lg w-full mt-4 p-3" required
                   placeholder="رمز عبور خود را وارد کنید" v-model="password">
          </div>

          <button class="mt-10 mb-6 bg-accent rounded-lg py-3 w-full hover:bg-accent/90">ورود</button>
        </form>

        <a href="#" class="text-muted">فراموشی رمزعبور</a>
      </div>

    </div>
  </div>
</template>

<script>

export default {
  name: "LoginView",
  data() {
    return {
      inputPhone: {
        value: '',
        error: '',
      },
      password: '',
      reLogin: false,
      loginError: false
    }
  },
  created() {
    this.reLogin = this.$route.query.reLogin
  },
  methods: {
    async login() {
      if (this.validatePhoneNumber()) {
        let user = {
          phone: this.inputPhone.value,
          password: this.password
        }
        this.$store.dispatch('login', user)
            .then((user) => {
              if (user.role.type === 'admin') {
                this.$router.replace('/')
              } else if (user.role.type === 'restaurant') {
                this.$router.replace('/orders/restaurant')
              } else if (user.role.type === 'shop') {
                this.$router.replace('/orders/shop')
              } else if (user.role.type === 'caffe') {
                this.$router.replace('/orders/caffe')
              } else if (user.role.type === 'housekeeping') {
                this.$router.replace('/')
              } else if (user.role.type === 'reception') {
                this.$router. replace('/')
              }
            })
            .catch((err) => {
              this.loginError = err
            })
      }
    },
    validatePhoneNumber() {
      let result = true

      if (!this.inputPhone.value) {
        this.inputPhone.error = "لطفا شماره خود را وارد کنید"

        result = false
      } else if (this.inputPhone.value.length !== 11) {
        this.inputPhone.error = "شماره همراه باید 11 رقم باشد"

        result = false
      } else if (this.inputPhone.value.substr(0, 2) !== '09') {
        this.inputPhone.error = "شماره همراه باید با 09 شروع شود"

        result = false
      }

      return result
    }
  },
}
</script>

<style scoped>
#login-form {
  background-image: url("../assets/img/bg_login.png");
  @apply bg-cover bg-no-repeat
}

.login-bg {
  background-image: url("../assets/img/login_banner.jpg");
  @apply relative bg-cover bg-center
}

.login-bg:before {
  content: '';
  background-image: url("../assets/img/login-gradient.png");
  @apply absolute top-0 bottom-0 right-0 left-0 bg-cover bg-center
}

.login-bg:after {
  content: "";
  background: rgba(0, 0, 0, 0.25);
  @apply absolute top-0 bottom-0 right-0 left-0 bg-cover bg-center
}
</style>